'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'cup-straw';
var width = 384;
var height = 512;
var aliases = [129380];
var unicode = 'e363';
var svgPathData = ['M64.1 128l255.8 0-28.1 337.3c-.7 8.3-7.6 14.7-15.9 14.7l-167.7 0c-8.3 0-15.3-6.4-15.9-14.7L64.1 128z', 'M232.6-16c-21.7 0-40.8 14.6-46.4 35.6L165.8 96 16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 28.3 340c2.1 24.9 22.9 44 47.8 44l167.7 0c25 0 45.8-19.1 47.8-44l28.3-340 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-169 0 18.2-68.1c1.9-7 8.2-11.9 15.5-11.9L272 16c8.8 0 16-7.2 16-16s-7.2-16-16-16l-39.4 0zM64.1 128l255.8 0-28.1 337.3c-.7 8.3-7.6 14.7-15.9 14.7l-167.7 0c-8.3 0-15.3-6.4-15.9-14.7L64.1 128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCupStraw = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;